import { render, staticRenderFns } from "./TimelinePredefinitionList.vue?vue&type=template&id=f704459c&scoped=true"
import script from "./TimelinePredefinitionList.vue?vue&type=script&lang=js"
export * from "./TimelinePredefinitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f704459c",
  null
  
)

export default component.exports